import React, { FC } from 'react';

import { format } from '@eGroupTeam/utils/dateUtils';
import useOrgMpTransactionRecords from 'utils/useOrgMpTransactionRecords';
import { useSelector } from 'react-redux';
import { getSelectedOrg } from 'redux/modules/common';
import DataTable, { useDataTable } from '@eGroupTeam/material-module/DataTable';
import Main from '@eGroupTeam/material-layout/Main';
import {
  TableRow,
  TableCell,
  Typography,
  Container,
  Paper,
} from '@eGroupTeam/material';
import {
  Activity,
  MicepointTransactionRecord,
} from 'types';
import {
  MicepointTransactionRecordType,
} from 'enums'
import { useHistory } from 'react-router';

export interface ActivityTransactionsProps {
  activity: Activity;
}

const ActivityTransactions: FC<ActivityTransactionsProps> = ({ activity }) => {
  const history = useHistory();
  const selectedOrg = useSelector(getSelectedOrg);
  const {
    handleSearchChange,
    handleChangePage,
    handleRowsPerPageChange,
    payload,
    page,
    rowsPerPage,
  } = useDataTable('transactions', {}, {
    fromKey: 'startIndex',
    sizeKey: 'size',
  });
  const { data, isValidating, response } = useOrgMpTransactionRecords(
    {
      organizationId: selectedOrg.get('organizationId'),
    },
    {
      activityId: activity.activityId,
      ...payload,
    }
  );

  const renderColumns = (rowData: string[]) => (
    <TableRow>
      {rowData.map((el) => (
        <TableCell key={el}>
          <Typography variant="body2">{el}</Typography>
        </TableCell>
      ))}
    </TableRow>
  );

  const renderDataRow = (rowData: unknown) => {
    const order = rowData as MicepointTransactionRecord;
    return (
      <TableRow
        key={order.paymentOrder.paymentOrderId}
        hover
        onClick={() => {
          history.push(
            `/me/activities/${activity.activityId}/transactions/${order.paymentOrder.paymentOrderId}`
          );
        }}
      >
        <TableCell>
          {
            MicepointTransactionRecordType[
              order.micepointTransactionRecordType
            ]
          }
        </TableCell>
        <TableCell>
          {order.micepointTransactionRecordAmount}
        </TableCell>
        <TableCell>
          {format(order.micepointTransactionRecordCreateDateString, 'PP pp')}
        </TableCell>
      </TableRow>
    );
  };

  return (
    <Main>
      <Container>
        <Paper>
          <DataTable
            minWidth={1200}
            title="MICEPoint 交易紀錄"
            size="small"
            data={data?.source ?? []}
            SearchBarProps={{
              placeholder: '搜尋',
              onChange: handleSearchChange,
              defaultValue: payload.query,
            }}
            columns={['交易類型', '交易點數', '交易時間']}
            serverSide
            renderColumns={renderColumns}
            renderDataRow={renderDataRow}
            loading={isValidating}
            isEmpty={response?.status === 204}
            MuiTablePaginationProps={{
              count: data?.total ?? 0,
              labelRowsPerPage: '每頁幾筆',
              page,
              rowsPerPage,
              onPageChange: handleChangePage,
              onRowsPerPageChange: handleRowsPerPageChange,
            }}
          />
        </Paper>
      </Container>
    </Main>
  );
};

export default ActivityTransactions;
